module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-unactive@3x-4760b2f6.svg";